module.exports = __webpack_public_path__ + "static/RESUME - Vincent Widjaya-88f59adcfbf75d2c8453fd641d6c2ad5.pdf";